// src/data/constants.js

export const LIMITS = {
  free: { photos: 3, memories: 4, letter: 200, schoolPhotos: 10 },
  pro: { photos: 10, memories: 12, letter: 1000, schoolPhotos: 50 },
};

export const NAV_SECTIONS = [
  {
    group: 'Customize Book',
    items: [
      { key: 'photos', label: 'Personal Photos', icon: '📷' },
      { key: 'letter', label: 'Personal Note', icon: '💌' },
      { key: 'memories', label: 'Growing up memories', icon: '⭐' },
      { key: 'school', label: 'School Photos', icon: '🏫' },
    ],
  },
  {
    group: 'Book Settings',
    items: [
      { key: 'cover', label: 'Book Cover', icon: '📚' },
      { key: 'child', label: 'Child Details', icon: '✏️' },
    ],
  },
  {
    group: 'Order & Delivery',
    items: [
      { key: 'order', label: 'Order & Delivery', icon: '📦' },
    ],
  },
];

export const COVER_OPTIONS = [
  { id: 'garden', name: 'Garden Adventure', emoji: '🌻', gradient: 'linear-gradient(135deg,#e8f5e9,#c8e6c9)' },
  { id: 'space', name: 'Space Explorer', emoji: '🚀', gradient: 'linear-gradient(135deg,#e3f2fd,#bbdefb)' },
  { id: 'ocean', name: 'Under the Sea', emoji: '🐠', gradient: 'linear-gradient(135deg,#e0f7fa,#b2ebf2)' },
  { id: 'safari', name: 'Safari Friends', emoji: '🦁', gradient: 'linear-gradient(135deg,#fff8e1,#ffecb3)' },
];

export const MEMORY_PROMPTS = [
  { id: 'm1', title: 'Favorite Color', options: ['Blue', 'Pink', 'Rainbow', 'Green', 'Purple', 'Red', 'Yellow'], value: 'Rainbow' },
  { id: 'm2', title: 'Halloween Costume', options: ['Spider-Man', 'Princess', 'Dinosaur', 'Superhero', 'Witch', 'Pumpkin'], value: '' },
  { id: 'm3', title: 'Best Friend', options: [], value: '', freeText: true },
  { id: 'm4', title: 'Favorite Song', options: ['Baby Shark', 'Let It Go', 'Wheels on the Bus', 'Old MacDonald', 'Twinkle Star'], value: '' },
  { id: 'm5', title: 'When I Grow Up', options: ['Astronaut', 'Doctor', 'Teacher', 'Artist', 'Firefighter', 'Chef'], value: '' },
  { id: 'm6', title: 'Favorite Food', options: ['Pizza', 'Mac & Cheese', 'Chicken Nuggets', 'Ice Cream', 'Pasta', 'Fruit'], value: '' },
  { id: 'm7', title: 'Favorite Animal', options: ['Dog', 'Cat', 'Unicorn', 'Dinosaur', 'Butterfly', 'Elephant'], value: '' },
  { id: 'm8', title: 'Favorite Book', options: [], value: '', freeText: true },
];

export const MOCK_CHILDREN = [
  { id: 1, name: 'Arya', gender: 'Girl', age: 4, classroom: 'Sunshine Room', coverStyle: 'garden' },
  { id: 2, name: 'Veer', gender: 'Boy', age: 3, classroom: 'Rainbow Room', coverStyle: 'space' },
];

export const MOCK_SCHOOL_PHOTOS = {
  'First Day': Array.from({ length: 8 }, (_, i) => ({ id: `fd-${i}`, selected: i < 3 })),
  'Arts & Crafts': Array.from({ length: 6 }, (_, i) => ({ id: `ac-${i}`, selected: i < 2 })),
  'Outdoor Play': Array.from({ length: 10 }, (_, i) => ({ id: `op-${i}`, selected: i < 4 })),
  'Celebrations': Array.from({ length: 7 }, (_, i) => ({ id: `cl-${i}`, selected: i < 2 })),
  'Graduation': Array.from({ length: 5 }, (_, i) => ({ id: `gr-${i}`, selected: i < 3 })),
};

export const PRICE_PER_BOOK = 34.99;
export const SHIPPING_COST = 5.99;
export const FREE_SHIPPING_THRESHOLD = 3;


export const TIERS = {
  free: {
    id: 'free',
    name: 'Free',
    price: 0,
    features: {
      photos: 3,
      schoolPhotos: 10,
      memories: 4,
      letterChars: 200,
    },
  },
  photos_plus: {
    id: 'photos_plus',
    name: 'Photos+',
    price: 4.99,
    tagline: 'More personal photos',
    features: {
      photos: 15,
      schoolPhotos: 10,
      memories: 4,
      letterChars: 200,
    },
    highlights: ['15 personal photos (up from 3)'],
    color: '#0066CC',
    bgSelected: 'linear-gradient(135deg, #F0F7FF, #E0EDFF)',
    borderSelected: '#B3D4FF',
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 9.99,
    tagline: 'Everything upgraded',
    badge: 'BEST VALUE',
    features: {
      photos: 15,
      schoolPhotos: 50,
      memories: 12,
      letterChars: 1000,
    },
    highlights: [
      '15 personal photos (up from 3)',
      '50 school photo picks (up from 10)',
      '12 memories (up from 4)',
      'Longer letters (up from 200 characters each)',
      'Priority printing',
    ],
    color: '#1d1d1f',
    bgSelected: 'linear-gradient(135deg, #F5F5F7, #ECECEE)',
    borderSelected: '#D1D1D6',
  },
};

export const FEATURE_LABELS = {
  photos: 'Personal photos',
  schoolPhotos: 'School photo picks',
  memories: 'Growing up memories',
  letterChars: 'Letter characters',
};


export const GENDERS = [
  { label: 'All', value: -1 },
  { label: 'Male', value: 1 },
  { label: 'Female', value: 0 }
];
export const RACES = [
  { label: 'All', value: '' },
  { label: 'Caucasian', value: 'CAUCASIAN' },
  { label: 'Indian', value: 'INDIAN' },
  { label: 'Asian', value: 'ASIAN' },
  { label: 'African american', value: 'AFRICAN_AMERICAN' },
  { label: 'Mixed', value: 'MIX' }
];
export const HAIR_COLORS = [
  { label: 'All', value: '' },
  { label: 'Black', value: 'BLACK' },
  { label: 'Brunette', value: 'BRUNETTE' },
  { label: 'Blonde', value: 'BLONDE' },
  { label: 'Brown', value: 'BROWN' }
];
export const HAIR_STYLES = [
  { label: 'All', value: '' },
  { label: 'Short', value: 'SHORT' },
  { label: 'Long', value: 'LONG' }
];
export const EYE_COLORS = [
  { label: 'All', value: '' },
  { label: 'Brown', value: 'BROWN' },
  { label: 'Blue', value: 'BLUE' },
  { label: 'Hazel', value: 'HAZEL' },
  { label: 'Gray', value: 'GRAY' }
];
export const AGE_GROUPS = [
  { label: 'All', value: '' },
  { label: 'Infant', value: 'INFANT' },
  { label: 'Toddler', value: 'TODDLER' },
  { label: 'PreK', value: 'PREK' },
  { label: 'Preschool', value: 'PRESCHOOL' }
];